import { ATS_API_URL } from '../config';
import { httpClient } from './baseDataProvider';
import { isRealDocumentId } from '../componets/DocumentAnalysis/documentMoveValidation';

const sourceTypes = {
  3: { endpoint: 'getIncome', section: 'employment_details', sources: 'employer', recordKey: 'EmployerNumber', sourceKey: 'EmployerNumber' },
  6: { endpoint: 'getbank', section: 'banking_details', sources: 'banking', recordKey: 'BankStatementNumber', sourceKey: 'bank_statement_number' },
  7: { endpoint: 'getotherincome', section: 'other_income_details', sources: 'otherincome', recordKey: 'OtherIncomeNumber', sourceKey: 'other_income_number' },
};

const matchesSource = (
  item: any,
  sourceKey: string,
  sourceNumber: unknown
) => {
  const expected = String(sourceNumber);
  // Deleted-doc rows may expose either the display source number or the
  // employer/bank row id (mstApplicationDocument.EmployerNumber is an FK).
  return (
    String(item?.[sourceKey]) === expected ||
    String(item?.id) === expected
  );
};

export const assertDocumentRestoreCapacity = async (record: any) => {
  const sourceType = sourceTypes[Number(record?.DocumentTypeID)] as typeof sourceTypes[3] | undefined;
  if (!sourceType) return;

  const sourceNumber = record[sourceType.recordKey];
  // Core-api enforces the real limit on restore. Only block here when we can
  // positively prove the source is already full; otherwise let restore proceed.
  if (!record.trn_id || !isRealDocumentId(sourceNumber)) {
    return;
  }

  let json: any;
  try {
    // Read current server data on every restore; cached counts may predate uploads.
    ({ json } = await httpClient(
      `${ATS_API_URL}/applicant/income/${sourceType.endpoint}/${encodeURIComponent(record.trn_id)}`
    ));
  } catch {
    return;
  }

  const sources = json?.records?.[sourceType.section]?.[sourceType.sources];
  const source = Array.isArray(sources)
    ? sources.find((item) => matchesSource(item, sourceType.sourceKey, sourceNumber))
    : undefined;
  if (!source || !Array.isArray(source.files)) {
    return;
  }

  const documentIds = new Set(
    source.files
      .filter((file) => isRealDocumentId(file.application_document_id))
      .map((file) => String(file.application_document_id))
  );
  if (documentIds.size >= 8) {
    throw Object.assign(
      new Error('Cannot restore this file. This source has reached the limit of 8 files. Delete a file from this source before restoring.'),
      { code: 'DOCUMENT_RESTORE_SOURCE_FULL' }
    );
  }
};
